import { render } from "./RqSummaryCard.vue?vue&type=template&id=2c344b5f"
import script from "./RqSummaryCard.vue?vue&type=script&lang=js"
export * from "./RqSummaryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__